import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Title = makeShortcode("Title");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Title text="Projects" mdxType="Title" />
    <h4>{`Numerai`}</h4>
    <h5>{`Tournament (Classic)`}</h5>
    <h6>{`With legacy dataset:`}</h6>
    <p><a parentName="p" {...{
        "href": "https://numer.ai/tigerblood1"
      }}>{`Tigerblood1`}</a>{` |
`}<a parentName="p" {...{
        "href": "https://numer.ai/tigerblood2"
      }}>{`Tigerblood2`}</a>{` |
`}<a parentName="p" {...{
        "href": "https://numer.ai/tigerblood3"
      }}>{`Tigerblood3`}</a>{` |
`}<a parentName="p" {...{
        "href": "https://numer.ai/tigerblood4"
      }}>{`Tigerblood4`}</a>{` |
`}<a parentName="p" {...{
        "href": "https://numer.ai/tigerblood5"
      }}>{`Tigerblood5`}</a>{` |
`}<a parentName="p" {...{
        "href": "https://numer.ai/tigerblood6"
      }}>{`Tigerblood6`}</a>{` |
`}<a parentName="p" {...{
        "href": "https://numer.ai/tigerblood7"
      }}>{`Tigerblood7`}</a>{` |
`}<a parentName="p" {...{
        "href": "https://numer.ai/tigerblood8"
      }}>{`Tigerblood8`}</a></p>
    <h6>{`With super massive dataset:`}</h6>
    <p><a parentName="p" {...{
        "href": "https://numer.ai/mp_king_sejong"
      }}>{`King Sejong`}</a>{` |
`}<a parentName="p" {...{
        "href": "https://numer.ai/mp_shin_saimdang"
      }}>{`Shin Saimdang`}</a>{` |
`}<a parentName="p" {...{
        "href": "https://numer.ai/mp_yi_yi"
      }}>{`Yi Yi`}</a>{` |
`}<a parentName="p" {...{
        "href": "https://numer.ai/mp_yi_hwang"
      }}>{`Yi Hwang`}</a>{` `}</p>
    <h5>{`Signals`}</h5>
    <p><a parentName="p" {...{
        "href": "https://numer.ai/tigerblood1"
      }}>{`Onirex1`}</a></p>
    <p>{`Buy my model predictions on `}<a parentName="p" {...{
        "href": "https://numerbay.ai/"
      }}>{`Numerbay.ai`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://numerbay.ai/p/187/numerai-predictions-tigerblood1"
      }}>{`Tigerblood1`}</a>{` |
`}<a parentName="p" {...{
        "href": "https://numerbay.ai/p/188/numerai-predictions-tigerblood2"
      }}>{`Tigerblood2`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      